export const SUPER_ADMIN_EMAILS = [
    'linh.hnp@due.edu.vn',
    'anh.dq@due.edu.vn'
];

/**
 * Kiểm tra xem email có thuộc nhóm Super Admin hay không
 * @param {string} email
 * @returns {boolean}
 */
export const isSuperAdmin = (email) => {
    if (!email) return false;
    return SUPER_ADMIN_EMAILS.includes(email.toLowerCase().trim());
};